import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner',
  template: `
    <div class="spinner-wrapper">
      <div class="itoSpinner itoSpinMixed">
        <div class="ito1"></div>
        <div class="ito2"></div>
        <div class="ito3"></div>
      </div>
    </div>
  `,
  styles: [
    `
      .spinner-wrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        background-color: rgba(255, 255, 255, 0.5);
        z-index: 998;
      }

      @keyframes itoani1 {
        from {
          transform: rotate(0deg);
        }

        to {
          transform: rotate(360deg);
        }
      }

      @keyframes itoani2 {
        from {
          transform: rotate(360deg);
        }

        to {
          transform: rotate(0deg);
        }
      }

      .itoSpinner {
        height: 104px;
        width: 104px;
        position: relative;
        background-color: transparent;
      }

      .itoSpinner .ito1 {
        width: 104px;
        height: 104px;
      }

      .itoSpinner .ito1:before {
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        border-top: solid 7px #2d6991;
        border-bottom: solid 7px #2d6991;
        border-left: solid 7px #2d6991;
        border-right: solid 7px transparent;
        content: "";
        border-radius: 52px;
      }

      .itoSpinner .ito1:after {
        border: 7px solid #fab93c;
        border-radius: 50px;
        bottom: 0;
        content: "";
        display: block;
        height: 10px;
        left: 0;
        margin: auto;
        position: absolute;
        right: 0;
        top: 0;
        width: 10px;

        height: 25px;
        width: 25px;
      }

      .itoSpinner .ito2 {
        height: 84px;
        left: 10px;
        position: absolute;
        top: 10px;
        width: 84px;
      }

      .itoSpinner .ito2:before {
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        border-top: solid 7px #71a0c0;
        border-bottom: solid 7px #71a0c0;
        border-left: solid 7px #71a0c0;
        border-right: solid 7px transparent;
        content: "";
        border-radius: 50px;
      }

      .itoSpinner .ito2:after {
        border-top: solid 7px #bbe5f3;
        border-bottom: solid 7px #bbe5f3;
        border-left: solid 7px #bbe5f3;
        border-right: solid 7px transparent;
        border-radius: 50px;
        bottom: 0;
        content: "";
        display: block;
        left: 0;
        margin: auto;
        position: absolute;
        right: 0;
        top: 0;
        height: 50px;
        width: 50px;

        height: 65px;
        width: 65px;
      }

      .itoSpinner .ito3 {
        border-top: solid 7px #ff820b;
        border-bottom: solid 7px #ff820b;
        border-left: solid 7px #ff820b;
        border-right: solid 7px transparent;
        border-radius: 50px;
        bottom: 0;
        content: "";
        display: block;
        height: 30px;
        left: 0;
        margin: auto;
        position: absolute;
        right: 0;
        top: 0;
        width: 30px;

        height: 45px;
        width: 45px;
      }

      .itoSpinner .ito1:before {
        transform: rotate(-45deg);
      }

      .itoSpinner .ito2:before {
        transform: rotate(-25deg);
      }

      .itoSpinner .ito2:after {
        transform: rotate(5deg);
      }

      .itoSpinner .ito3 {
        transform: rotate(45deg);
      }

      .itoSpinner.itoSpinRegular .ito1:before {
        animation: itoani1 1s infinite linear;
      }

      .itoSpinner.itoSpinRegular .ito2:before {
        animation: itoani1 1.2s infinite linear;
      }

      .itoSpinner.itoSpinRegular .ito2:after {
        animation: itoani1 1.3s infinite linear;
      }

      .itoSpinner.itoSpinRegular .ito3 {
        animation: itoani1 1.4s infinite linear;
      }

      .itoSpinner.itoSpinMixed .ito1:before {
        animation: itoani1 1s infinite ease;
      }

      .itoSpinner.itoSpinMixed .ito2:before {
        animation: itoani2 1.2s infinite ease-in;
      }

      .itoSpinner.itoSpinMixed .ito2:after {
        animation: itoani1 1.3s infinite ease-in-out;
      }

      .itoSpinner.itoSpinMixed .ito3 {
        animation: itoani2 1.6s infinite ease;
      }

    `
  ]
})
export class SpinnerComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
